/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  DefundTenantGuaranteeOptions,
  DefundTenantGuaranteeStatus200,
  DefundTenantGuaranteeStatus400,
  DefundTenantGuaranteeStatus500,
} from '../types/DefundTenantGuarantee'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { defundTenantGuarantee } from '../clients/defundTenantGuarantee'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const defundTenantGuaranteeMutationKey = () =>
  [{ url: '/v1/tenants/:tenant_id/defund_guarantee' }] as const

export function defundTenantGuaranteeMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = defundTenantGuaranteeMutationKey()
  return mutationOptions<
    DefundTenantGuaranteeStatus200,
    ResponseErrorConfig<DefundTenantGuaranteeStatus400 | DefundTenantGuaranteeStatus500>,
    DefundTenantGuaranteeOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return defundTenantGuarantee({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Creates a guarantee-fund ledger entry with tx_kind WITHDRAWAL.
 * @summary Deduct funds from the guarantee fund for a tenant.
 * {@link /v1/tenants/:tenant_id/defund_guarantee}
 */
export function useDefundTenantGuarantee<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DefundTenantGuaranteeStatus200,
      ResponseErrorConfig<DefundTenantGuaranteeStatus400 | DefundTenantGuaranteeStatus500>,
      DefundTenantGuaranteeOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? defundTenantGuaranteeMutationKey()

  const baseOptions = defundTenantGuaranteeMutationOptions(config) as UseMutationOptions<
    DefundTenantGuaranteeStatus200,
    ResponseErrorConfig<DefundTenantGuaranteeStatus400 | DefundTenantGuaranteeStatus500>,
    DefundTenantGuaranteeOptions,
    TContext
  >

  return useMutation<
    DefundTenantGuaranteeStatus200,
    ResponseErrorConfig<DefundTenantGuaranteeStatus400 | DefundTenantGuaranteeStatus500>,
    DefundTenantGuaranteeOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DefundTenantGuaranteeStatus200,
    ResponseErrorConfig<DefundTenantGuaranteeStatus400 | DefundTenantGuaranteeStatus500>,
    DefundTenantGuaranteeOptions,
    TContext
  >
}
